<div class="fullwidth-layout-container" basepage="secondary">
  <div class="row" #prodDetailTitle>
    <div class="col">
      <div class="page-nav-header no-pills">
        <div class="back-container" style="display: flex">
          <button type="button" class="btn btn-transparent p-0" (click)="goBack()" aria-label="back">
            <fa-icon icon="arrow-left" class="circle-icon-btn" aria-hidden="true"></fa-icon>
            <span class="sr-only">{{ "productDetail.back_sr_only" | translate }}</span>
          </button>
          @if (!snapshot && !missingFenderSerial) {
            <myp-skeleton-loader type="line" width="200px" height="30px"></myp-skeleton-loader>
          }
          <div>
            <fui-heading [text]="title" [level]="2"></fui-heading>
            @if (subTitle) {
              <span class="sub-title d-block">{{ subTitle }}</span>
            }
            @if (snapshot?.product?.version) {
              <span class="version" (click)="imageClick()">v{{ snapshot.product.version }}</span>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (loading) {
    <myp-skeleton-loader type="product-detail"></myp-skeleton-loader>
  }
  @if (!loading && missingFenderSerial) {
    <div class="row">
      <div class="col">
        <img style="max-width: 700px; max-height: 600px; margin: 0 auto; border-radius: 10px" [src]="missingFenderSerial.bodyImageUrl" />
        <div class="m-y-20 text-center">
          {{ "products.register.missing_fender_serial.thanks_entering_manual" | translate }}
        </div>
        <div class="text-center m-y-20">
          <span class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</span>
          <span class="mono key t-20 bold brand-color">{{ displaySerialNumber | uppercase }}</span>
          <br />
          <br />
          <span class="small-btn red deregister" (click)="removeHardware(listProduct)">{{ "product_detail.deregister" | translate }}</span>
        </div>
      </div>
    </div>
  }

  @if (!loading && snapshot) {
    <div class="row">
      <div class="col-sm-3 col-lg-2 col-12" #prodDetailSidebar>
        <div #prodDetailSidebarSticky [class.sticky-sidebar]="shouldBeSticky" [ngStyle]="{ width: sidebarWidth + 'px' }">
          @if (productImage) {
            <div class="prod_img-container">
              <img class="prod_img" [src]="productImage" (click)="imageClick()" />
            </div>
          }
          @if (listProduct?.includedInSubscription) {
            <!-- <div class="d-flex t-12 align-items-center m-y-10">
            <img src="./assets/icons/plus-icon-blue.png" class="s1plus-icon-md m-r-5" alt="Studio One Plus icon" />
            <span class="serial-btn info">{{ "sphere.included_in_membership" | translate }}</span>
          </div>
          <div class="m-b-20" *ngIf="listProduct.releaseDate || listProduct.aquired">
            <span class="serial-btn info t-12">{{ "sphere.date_added" | translate }}: {{ listProduct.releaseDate || listProduct.aquired | date }}</span>
          </div> -->
          }
          @if (licenses) {
            <myp-installer-buttons
              [showAllSystems]="showAllSystems"
              [downloads]="snapshot.downloads"
              [license]="licenses ? licenses[0] : null"
              [previousVersions]="snapshot.previousVersions"
              [firmwareList]="snapshot.firmware"
              [product]="snapshot.product"
              [showManageActivations]="(isS15 || isS16 || isS17) && listProduct?.includedInSubscription && !loadingLicenses"
            ></myp-installer-buttons>
          }
        </div>
      </div>
      <div class="col-12 col-lg-10 col-sm-9">
        <div class="prod_details">
          <div #prodDetailHead>
            @if (snapshot.product.stringId != "notion6.demo") {
              <div id="text_details">
                @if (snapshot.product.description) {
                  <div class="m-b-10" [innerHTML]="helperService.convertLineBreaks(snapshot.product.description) | safe: 'html'"></div>
                }
                @if (snapshot.product.stringId != "presonushub" && snapshot.product.partnerKey) {
                  <span class="sm b">
                    {{
                      (snapshot.product.stringId == "eastwest.composercloud"
                        ? "product_detail.redeem_code"
                        : snapshot.product.categoryId == "software"
                          ? "product_detail.product_keys"
                          : "product_detail.serial_numbers"
                      ) | translate
                    }}
                  </span>
                }
                @if (!productService.hasGottenProducts) {
                  <span class="font-italic">{{ "productDetail.loading_product_data" | translate }}</span>
                }
                @if (loadingLicenses) {
                  <div>
                    <fa-icon icon="spinner" [animation]="'spin'"></fa-icon>
                    {{ "productDetail.loading_licenses" | translate }}
                  </div>
                }
                @if (snapshot.missingFenderSerialData) {
                  <div class="detail_keys secondary-content-bg border-radius10 p-10">
                    <div>
                      <div>
                        <small class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</small>
                        <span class="mono key">{{ displaySerialNumber | uppercase }}</span>
                      </div>
                    </div>
                  </div>
                }

                @if (listProduct.isMissingFenderSerial && !missingFenderSerial) {
                  <!-- this is a missingFenderSerial with a sku entered. -->
                  <div class="detail_keys secondary-content-bg border-radius10 p-10">
                    <small class="text-muted d-block">{{ "product_detail.serial_number" | translate }}</small>
                    <span class="mono key">{{ listProduct.serial | uppercase }}</span>
                    <br />
                    <span class="unlock-key">{{ "productDetail.sku" | translate }} {{ listProduct.stringId }}</span>
                    <br />
                    <span class="small-btn red deregister" (click)="removeHardware(listProduct)">{{ "product_detail.deregister" | translate }}</span>
                  </div>
                }

                @for (license of licenses; track license) {
                  @if (license.productId == snapshot.product.id && license.categoryId != "subscription" && (license.showKey || showKeyActions)) {
                    <div class="detail_keys secondary-content-bg border-radius10 p-10">
                      @if (snapshot.product.partnerKey || license.showKey) {
                        <div>
                          @if (snapshot.product.partnerName != "third_party" && snapshot.product.stringId != "notionmobile3") {
                            <div>
                              <small class="text-muted d-block">{{ (license.productKeyString ? "product_detail.product_key" : "product_detail.serial_number") | translate }}</small>
                              <span class="mono key">{{ license.productKeyString || license.hardwareSerialNumber | uppercase }}</span>
                            </div>
                          }
                          @if (snapshot.product.partnerName == "third_party") {
                            <div>
                              <small class="text-muted d-block">{{ (license.productKeyString ? "product_detail.product_key" : "product_detail.serial_number") | translate }}</small>
                              <span class="mono key">{{ license.productKeyString || license.hardwareSerialNumber }}</span>
                              <br />
                              @if (license.productUnlockKey) {
                                <span class="unlock-key">{{ "product_detail.unlock_key" | translate }}: {{ license.productUnlockKey | uppercase }}</span>
                              }
                              <br />
                            </div>
                          }
                          @if (snapshot.fenderProductSpecs && snapshot.product.fmic_material_number) {
                            <span class="unlock-key">
                              {{ "productDetail.sku" | translate }} {{ snapshot.product.fmic_material_number }}
                              <br />
                            </span>
                          }
                          @if (license.productKeyOptionTitle) {
                            <span class="unlock-key">{{ "product_detail.vendor" | translate }}: {{ license.productKeyOptionTitle }}</span>
                          }
                        </div>
                      }
                      @if (showKeyActions) {
                        <div class="serial_actions">
                          @if (snapshot.product.stringId != "presonushub" && snapshot.product.categoryId != "subscription") {
                            <span class="serial-btn info">
                              {{ license.categoryId == "subscription" ? ("productDetail.renewed" | translate) : ("product_detail.registered" | translate) }}: {{ license.aquired | date }}
                            </span>
                          }
                          @if (license.expirationDate) {
                            <span class="serial-btn info">{{ "account.expiration_date" | translate }} {{ license.expirationDate | date }}</span>
                          }
                          @if (!license.upgraded && snapshot.product.canUpgrade && snapshot.product.stringId != "presonushub") {
                            <a class="small-btn blue" (click)="showUpgrade(license)">
                              {{ "general.upgrade" | translate }}
                            </a>
                          }
                          @if (
                            snapshot.product.categoryId != "hardware" &&
                            snapshot.product.licenseScheme == 0 &&
                            !snapshot.product.partnerName &&
                            snapshot.product.type != "bundle" &&
                            snapshot.product.stringId != "presonushub" &&
                            snapshot.product.stringId != "studiohub" &&
                            snapshot.product.categoryId != "subscription" &&
                            snapshot.product.stringId != "notionmobile3" &&
                            !snapshot.fenderProductSpecs
                          ) {
                            <button
                              class="small-btn offline-activation offline-activation-btn"
                              tabindex="0"
                              (keyup.enter)="selectedLicense = license"
                              (click)="selectedLicense = license"
                              [ngbPopover]="popContent"
                              [popoverTitle]="popTitle"
                            >
                              {{ "product_detail.activations.offline_title" | translate }}
                            </button>
                          }
                          @if (license.transferable && license.transferFee) {
                            <button class="small-btn transfer" tabindex="0" (click)="showTransferLicense(license)">
                              {{ "product_detail.transfer_license.transfer_license" | translate }}
                            </button>
                          }
                          @if (
                            snapshot.product.categoryId != "subscription" && (snapshot.product.categoryId == "software" || (snapshot.product.categoryId == "extensions" && license.activations?.length))
                          ) {
                            @if (license.activations?.length && snapshot.product.licenseScheme != 1) {
                              <button class="small-btn manage" (click)="showManageActivations(license)">
                                {{ (license.activations?.length || 0) + "/" + license.maxActivations }} {{ "product_detail.activations.activations" | translate }} - {{ "general.manage" | translate }}
                              </button>
                            }
                            @if (!license.activations?.length) {
                              <span class="serial-btn info">
                                {{ (snapshot.product.stringId == "notion6" ? license.usedActivations : license.activations?.length) + "/" + license.maxActivations }}
                                {{ "product_detail.activations.activations" | translate }}
                              </span>
                            }
                          }
                          @if (snapshot.product.categoryId != "extension" && snapshot.product.categoryId != "software") {
                            <span class="small-btn red deregister" (click)="removeHardware(license)">{{ "product_detail.deregister" | translate }}</span>
                          }
                        </div>
                      }
                      @if (license.extendedSupportDate && license.extendedSupportDate != "NO_EXTENDED_SUPPORT") {
                        <div class="t-12">
                          <span>{{ "product_detail.eligible_for_all_updates" | translate: { date: (license.extendedSupportDate | date) } }}</span>
                          -
                          <a class="small-btn blue" (click)="showUpgrade(license)">{{ "product_detail.extend" | translate }}</a>
                        </div>
                      }
                      @if ((!license.extendedSupportDate || license.extendedSupportDate == "NO_EXTENDED_SUPPORT") && license.fallbackVersion) {
                        <div class="t-12">
                          <span>{{ "product_detail.eligibility_for_updates" | translate: { version: (license.fallbackVersion | version) } }}</span>
                          @if (license.fallbackVersion.split(".")[1] < productPointVersion && userService.subDetails?.subscription?.status != "active") {
                            <br />
                            {{ "productDetail.to_access_latest_version" | translate: { version: product.version } }}
                            <a href="javascript:void(0)" class="small-btn blue" (click)="showUpgrade(license)" style="margin: 0px">{{ "productDetail.upgrade_license" | translate }}</a>
                            {{ "productDetail.or" | translate }}
                            <a [routerLink]="['/account/plan']" style="margin: 0px">{{ "productDetail.resubscribe" | translate }}</a>
                            {{ "productDetail.to_studio_one_pro_plus" | translate }}
                          }
                          @if (userService.subDetails?.subscription?.status == "active") {
                            {{ "productDetail.unlimited_access_message" | translate }}
                          }
                          <a href="https://www.presonus.com/pages/studio-one-pro-faq" target="_blank">{{ "productDetail.learn_more" | translate }}</a>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          </div>
          @if (productService.studioOneStatus?.status == "can_redeem_fsp8") {
            <div class="m-y-30">
              <h4 class="section-header m-b-10 m-t-30">{{ "newdash.special_offers" | translate }}</h4>
              <div class="d-flex align-items-center">
                <img [src]="contentService.logos[appService.app][appService.activeTheme].dawBox" style="width: 150px" alt="Fender Studio Pro 8 icon" class="m-r-10" />
                <div>
                  <span>{{ "productDetail.eligible_studio_one_seven" | translate }}</span>
                  <br />
                  <br />
                  <button class="btn btn-primary" (click)="showFspRedeem()">{{ "productDetail.redeem_now" | translate }}</button>
                </div>
              </div>
            </div>
          }
          <!-- <div class="trans-bg p-20 border-radius10 d-inline-block m-y-20" *ngIf="productService.studioOneStatus?.status == 'can_redeem_fsp8'">
        <h4 class="t-14 bold">{{ "productDetail.eligible_studio_one_seven" | translate }}</h4>
        <button class="btn btn-primary" (click)="showFspRedeem()">{{ "productDetail.redeem_now" | translate }}</button>
      </div> -->
          @if (s1OrNotion || installMethods) {
            <div id="install_instructions" class="m-t-20 m-b-20">
              @if (s1OrNotion) {
                <h4 class="section-header m-b-10 m-t-30">
                  {{ "product_detail.install_instructions.to_install" | translate }}
                </h4>
                @if (snapshot.product.licenseScheme != 1) {
                  <span>{{ "product_detail.install_instructions.download_installer" | translate }}</span>
                }
                @if (snapshot.product.licenseScheme == 1) {
                  <span>{{ "product_detail.install_instructions.notion_download_installer" | translate }}</span>
                }
              }
              @if (installMethods) {
                @for (method of installMethods; track method) {
                  <div>
                    @if (method == "s1") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_s1_title" | translate }}</span>
                        <br />
                        @if (snapshot.product.stringId == "presonus.fatchannel") {
                          <span>{{ "sphere.plugin_comes_s1" | translate }}</span>
                        }
                        @if (snapshot.product.stringId != "presonus.fatchannel") {
                          <span>{{ "sphere.download_plugin_installer" | translate }}</span>
                        }
                      </div>
                    }
                    @if (method == "hub") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_in_hub" | translate }}</span>
                        <br />
                        {{ "sphere.download_hub_installer" | translate }}
                        <br />
                        <span class="btn btn-primary m-t-20" (click)="downloadHub()">
                          {{ productService.productsByStringIDs["presonushub"] ? ("download.download" | translate) : ("sphere.redeem_and_download" | translate) }} PreSonus Hub
                        </span>
                      </div>
                    }
                    @if (method == "uc") {
                      <div class="m-t-20">
                        <span class="install_instructions_header">{{ "sphere.install_on_studiolive" | translate }}</span>
                        <br />
                        <span [innerHTML]="'sphere.first_download_uc' | translate"></span>
                        <br />
                        <a class="btn btn-primary" href="https://www.presonus.com/products/UC-Surface/downloads" target="_blank">{{ "sphere.download_uc" | translate }}</a>
                      </div>
                    }
                  </div>
                }
              }
            </div>
          }
          @if (snapshot.fenderProductSpecs) {
            <div class="m-t-20">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.specs" | translate }}
                <span class="section-header-link" (click)="specsCollapsed = !specsCollapsed">
                  {{ specsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="specsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!specsCollapsed) {
                <div class="specs-container" [ngStyle]="{ 'max-height': showAllSpecs ? 'none' : '565px' }">
                  @for (spec of allSpecs; track spec) {
                    <div class="m-b-20">
                      <span class="t-16 brandfont-bold">
                        {{
                          ("productDetail.specSections." + spec.Name | translate) === "productDetail.specSections." + spec.Name ? spec.Name : ("productDetail.specSections." + spec.Name | translate)
                        }}
                      </span>
                      <div class="guitar-specs-table">
                        @for (item of spec | keyvalue; track item) {
                          @if (item.key != "Name") {
                            <div class="spec-row">
                              <span class="spec-key">
                                {{ ("productDetail.specFields." + item.key | translate) === "productDetail.specFields." + item.key ? item.key : ("productDetail.specFields." + item.key | translate) }}:
                              </span>
                              <span class="spec-value">{{ item.value }}</span>
                            </div>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
                <button class="brand-btn-reverse sm m-t-20" (click)="showAllSpecs = !showAllSpecs">
                  {{ "productDetail.show" | translate }} {{ showAllSpecs ? ("productDetail.less" | translate) : ("productDetail.more" | translate) }}
                </button>
              }
            </div>
          }
          <div class="m-t-20">
            <myp-bundled-downloads [product]="snapshot.product" [bundledDownloads]="snapshot.bundledDownloads" [showAllSystems]="showAllSystems"></myp-bundled-downloads>
          </div>
          @if (snapshot.metadata?.videos?.length || snapshot.metadata?.lessons?.length || snapshot.metadata?.courses?.length) {
            <div class="flagship m-y-30">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.getting_started" | translate }}
              </h4>
              @if (snapshot.metadata.videos) {
                <div>
                  <!-- Watch this video to learn everything you need to know about getting started with {{ snapshot.product.title }}: -->
                  <div class="grid-container pad-10">
                    @for (videoId of snapshot.metadata.videos; track videoId) {
                      @if (contentService.videosById[videoId]) {
                        <myp-video-grid-item [video]="contentService.videosById[videoId]"></myp-video-grid-item>
                      }
                    }
                  </div>
                </div>
              }
              @if (snapshot.metadata.lessons) {
                <div class="m-t-30">
                  @for (lessonId of snapshot.metadata.lessons; track lessonId) {
                    @if (contentService.lessonMap[lessonId]) {
                      <myp-learn-list-item [item]="contentService.lessonMap[lessonId]"></myp-learn-list-item>
                    }
                  }
                </div>
              }
              @if (snapshot.metadata.courses) {
                <div class="m-t-30">
                  <!-- For a deep dive, complete this whole course to master {{ snapshot.product.title }}: -->
                  @for (courseId of snapshot.metadata.courses; track courseId) {
                    @if (contentService.courseMap[courseId]) {
                      <myp-learn-list-item [item]="contentService.courseMap[courseId]"></myp-learn-list-item>
                    }
                  }
                </div>
              }
            </div>
          }
          @if (hasExtrasOrOffers) {
            <h4 class="section-header m-b-10 m-t-30">
              {{ "productDetail.extras_and_offers" | translate }}
              <span class="section-header-link" (click)="extrasOffersCollapsed = !extrasOffersCollapsed">
                {{ extrasOffersCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                <fa-icon [icon]="extrasOffersCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
              </span>
            </h4>
            @if (!extrasOffersCollapsed) {
              <div>
                @for (license of licenses; track license) {
                  <div>
                    @if (license.offers && license.offers.length) {
                      <div class="trans-bg p-20 border-radius10 d-inline-block m-b-20">
                        <span class="t-14">{{ "newdash.you_are_elligible" | translate: { product: snapshot.product.title } }}</span>
                        <br />
                        <button class="btn btn-primary m-t-10" (click)="openOffers(license)">{{ "newdash.view_offers" | translate }}</button>
                      </div>
                    }
                  </div>
                }
                @if (productService.gettingProducts) {
                  <div class="m-y-10">
                    <myp-inline-loader [loading]="true" height="200px" spinnerName="gettingProductsLoader"></myp-inline-loader>
                  </div>
                }
              </div>
            }
          }
        </div>
        <div>
          @if (bundledProducts && bundledProducts.length) {
            <div class="children">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "product_detail.product_comes_with" | translate }}
                <span class="section-header-link" (click)="bundledProductsCollapsed = !bundledProductsCollapsed">
                  {{ bundledProductsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="bundledProductsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!bundledProductsCollapsed) {
                <div class="grid-container pad-10">
                  @for (prod of bundledProducts; track prod) {
                    <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod"></myp-product-tile>
                  }
                </div>
              }
            </div>
          }
          @if (snapshot && downloads && downloadSections?.length) {
            <div class="product-downloads" id="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "download.downloads" | translate }}
                <span class="section-header-link" (click)="downloadsCollapsed = !downloadsCollapsed">
                  {{ downloadsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="downloadsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!downloadsCollapsed) {
                <div>
                  <myp-product-downloads #productDownloads [downloads]="downloads" [downloadSections]="downloadSections" [product]="snapshot.product"></myp-product-downloads>
                </div>
              }
            </div>
          }
          @if (snapshot && snapshot?.samples?.length) {
            <div class="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.sound_samples" | translate }}
                <span class="section-header-link" (click)="samplesCollapsed = !samplesCollapsed">
                  {{ samplesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="samplesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!samplesCollapsed) {
                <div class="grid-container pad-10">
                  @for (smp of snapshot.samples; track smp) {
                    <div (click)="playSample(smp)" class="item-tile p-10">
                      <fa-icon icon="play-circle" class="t-20"></fa-icon>
                      <span class="brandfont-bold">{{ smp.title_products_audio }}</span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (hasThirdPartyKeys) {
            <div class="third-party-keys">
              <h4 class="section-header m-t-30 m-b-20">{{ "product_detail.third_party_keys" | translate }}</h4>
              @for (item of licenses; track item) {
                <div class="m-y-30">
                  @for (key of item.oemItems; track key) {
                    <div>
                      <strong>{{ "product_detail.product_key" | translate }}: {{ item.productKeyString }}</strong>
                      <br />
                      <span>
                        {{ key.title }} -
                        @if (!key.data && !key.loading) {
                          <span class="btn btn-primary btn-sm" (click)="getOemKey(item, key)">{{ "product_detail.claim_product_key" | translate }}</span>
                        }
                        @if (!key.loading && key.data) {
                          <span>{{ key.data }}</span>
                        }
                        @if (key.loading) {
                          <span>{{ "product_detail.claiming_key" | translate }}</span>
                        }
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (resources && resourcesSections?.length) {
            <div class="product-downloads">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "product_detail.product_resources" | translate }}
                <span class="section-header-link" (click)="resourcesCollapsed = !resourcesCollapsed">
                  {{ resourcesCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="resourcesCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!resourcesCollapsed) {
                <div>
                  <ul class="nav nav-pills m-b-10">
                    @for (section of resourcesSections; track section) {
                      <li class="nav-item">
                        <a class="nav-link" (click)="displayResourceSection(section)" tabindex="0" (keyup.enter)="displayResourceSection(section)" [class.active]="section.displayed">
                          {{ "general." + section.value | translate }}
                        </a>
                      </li>
                    }
                  </ul>
                  @if (displayedResourcesSection.value == "related_products") {
                    <div class="grid-container pad-10">
                      @for (prod of snapshot.relatedProducts; track prod) {
                        <myp-product-tile (tileClicked)="tileClick(prod)" [product]="prod"></myp-product-tile>
                      }
                    </div>
                  }
                  @if (displayedResourcesSection.value == "videos") {
                    <fui-video-rail [leftMargin]="false" [title]="'general.videos' | translate" [videos]="snapshot.videos" (showMoreVideos)="showMoreVideos()"></fui-video-rail>
                  }
                </div>
              }
            </div>
          }
          @if (snapshot?.product?.extendable && licenses) {
            <div class="product-downloads row">
              <div class="col-md-12">
                <h4 class="section-header m-t-30 m-b-20">{{ "product_detail.option_cards.option_card" | translate }}</h4>
                @if (optionCards && optionCards.length) {
                  <div>
                    @for (card of optionCards; track card) {
                      <div class="option-card">
                        <img [src]="card.imageUrl" />
                        <div>
                          <span class="title">{{ card.title }}</span>
                          <br />
                          <span class="details">
                            {{ "general.serial_number" | translate }}: {{ card.hardwareSerialNumber }}
                            <br />
                            {{ "product_detail.option_cards.prod_with_sn" | translate }} {{ card.parentSerial | uppercase }}
                          </span>
                        </div>
                        <div class="buttons">
                          <span class="btn btn-primary btn-sm" (click)="optionCardInstructions(card)">{{ "product_detail.option_cards.view_install_instructions" | translate }}</span>
                          <span class="btn btn-danger btn-sm" (click)="deregisterOptionCard(card)">
                            {{ (removingOptionCard ? "product_detail.option_cards.removing" : "product_detail.option_cards.remove") | translate }}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                }
                @if (!optionCards?.length) {
                  <span>{{ "product_detail.option_cards.no_option_cards" | translate }}</span>
                }
                <br />
                <br />
                <span class="btn btn-primary" (click)="addOptionCard()">{{ "product_detail.option_cards.register_option_card" | translate }}</span>
              </div>
            </div>
          }
          @if (highlights) {
            <div class="m-t-20">
              <h4 class="section-header m-b-10 m-t-30">
                {{ "productDetail.product_highlights" | translate }}
                <span class="section-header-link" (click)="highlightsCollapsed = !highlightsCollapsed">
                  {{ highlightsCollapsed ? ("sphere.expand" | translate) : ("sphere.collapse" | translate) }}
                  <fa-icon [icon]="highlightsCollapsed ? 'chevron-down' : 'chevron-up'"></fa-icon>
                </span>
              </h4>
              @if (!highlightsCollapsed) {
                <div class="row">
                  @for (highlight of highlights; track highlight; let i = $index; let last = $last) {
                    <div class="col-md-6 col-lg-4 m-b-50">
                      <div class="d-flex justify-content-center">
                        <img [src]="highlight.url" class="w-full" style="border-radius: 10px; max-width: 250px" />
                      </div>
                      <div class="m-t-10">
                        <span class="t-18 brandfont-bold">{{ highlight.title }}</span>
                        <br />
                        <span class="t-14">{{ highlight.description }}</span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          <div class="m-b-50"></div>
        </div>
      </div>
    </div>
  }
</div>

<ng-template #popContent>
  @if (snapshot?.product?.categoryId == "software") {
    <button (keyup.enter)="showActivateOffline(selectedLicense)" (click)="showActivateOffline(selectedLicense)" class="activate_software_manual btn btn-primary btn-success">
      <span class="glyphicon glyphicon-plus-sign"></span>
      {{ "product_detail.activations.activate_software" | translate }}
    </button>
  }
  @if (snapshot?.product?.categoryId == "software" && selectedLicense.activations?.length > 0) {
    <a
      class="download_license btn btn-primary btn-primary"
      target="_blank"
      [href]="
        env.phpBaseUrl +
        'products/download_license/' +
        user.id +
        '/' +
        selectedLicense.licenseId +
        '/' +
        selectedLicense.activations[0].activationCode +
        '/' +
        selectedLicense.activations[0].computerName +
        '/' +
        selectedLicense.productKeyString
      "
    >
      <span class="glyphicon glyphicon-download"></span>
      {{ "product_detail.activations.download_license" | translate }}
    </a>
  }
  @if (snapshot?.product?.categoryId == "extension" && snapshot?.product?.licenseScheme == 0 && !snapshot?.product?.partnerName) {
    <a class="download_license btn btn-primary btn-primary" target="_blank" [href]="env.phpBaseUrl + '/products/download_license/' + user.id + '/' + selectedLicense.licenseId">
      <span class="glyphicon glyphicon-download"></span>
      {{ "product_detail.activations.download_license" | translate }}
    </a>
  }
</ng-template>
<ng-template #popTitle>
  <span style="color: #333">{{ "product_detail.activations.offline_title" | translate }}</span>
</ng-template>
